import { Injectable } from '@angular/core';

import { Editor } from '@ckeditor/ckeditor5-core';
import { BehaviorSubject } from 'rxjs';

import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { DropdownOptionModel } from '../../../../../Common/Forms/models/dropdown-option.model';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { FullProfileAnimationModel } from '../../../../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../../Core/Dialogs/enums/overlay-animation.enum';
import {
    FallbackPersonalizationsDialogComponent
} from '../../../../Dialogs/components/FallbackPersonalizationsDialog/fallback-personalizations-dialog.component';
import { GLOBAL_URIS } from '../../../../Misc/helpers/formatting/global-uri.helper';


@Injectable()
export class CKPersonalizationService {

    isFooter: boolean = false;

    readonly mergeTagsInfoArticle = GLOBAL_URIS.personalizationsHelp;
    readonly footerMergeTagsInfoArticle = 'https://help.agilitypr.com/en/articles/6525391-using-merge-tags-to-edit-the-email-footer';

    constructor(
        public coreDialogService: CoreDialogService,
        public localizationService: LocalizationService
    ) {}

    setUpOptions(personalizationOptions: DropdownOptionModel[]): any[] {
        const options = personalizationOptions.slice() as any[];
        options.push({ isSeparator: true });
        options.push({
            label: 'FallbackPersonalizationDialog.heading',
            value: null,
            event: 'openEditPersonalizations',
            ariaLabel: this.localizationService.transform('MergeTagsEditDialog.heading.ariaLabel')
        });
        options.push({ isSeparator: true });
        options.push({
            label: 'Discover.personalizationTag.dropdownLabel',
            value: null,
            event: 'openPersonalizationLink',
            isExternalLink: true,
            ariaLabel: this.localizationService.transform('Discover.personalizationTag.dropdownLabel.ariaLabel')
        });
        options.forEach(x => x.label = this.localizationService.transform(x.label));

        return options;
    }

    handleItemsClicked(editor: Editor): void {
        editor.on('openEditPersonalizations', event => {
            this.openEditPersonalizationsDialog();
        });
        editor.on('openPersonalizationLink', event => {
            window.open(this.isFooter ? this.footerMergeTagsInfoArticle : this.mergeTagsInfoArticle, '_blank');
        });
    }

    openEditPersonalizationsDialog(): void {
        const overlayContainer = document.getElementById('main-content');
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: overlayContainer
            }
        };

        this.coreDialogService.open(FallbackPersonalizationsDialogComponent, io);
    }

    setIsFooter(isFooter: boolean): void {
        this.isFooter = isFooter;
    }

}
